import React, { useRef } from 'react';

import { timer } from 'apps/promo/helpers/utils';
import { CountrySearchService } from 'apps/promo/services/countrySearchService';

import { PromoSearchBar } from './PromoSearchBar';

export const PromoCountrySearchBar = (props) => {
    const timerID = useRef(null);
    const searchRef = useRef(null);

    const search = (value) => {
        const term = value;
        const resultList = CountrySearchService.search(props.countries, value);

        props.setCountryList({
            countryList: resultList,
            query: term,
        });
    };

    const debouncedSearch = (value) => (timerID.current = timer(timerID.current, () => search(value)));

    return (
        <PromoSearchBar
            searchRef={searchRef}
            placeholder={props.placeholder}
            onChange={(e) => debouncedSearch(e.target.value)}
            onCloseButtonClick={(e) => props.toggleSearch(e, false)}
        />
    );
};
